import { modalWindowConstants } from './../../actions/modalWindow/actionTypes';
import { produce } from 'immer';
const initialState = {
    isOpen: false,
    fileUrl: null,
    fileId: null,
    fileMimetype: null,
    fileBlob: null,
};

export function modalWindowReducer(state = initialState, action) {
    switch (action.type) {
        case modalWindowConstants.OPEN_MODAL_WINDOW:
            return produce(state, (draft) => {
                draft.isOpen = true;
            });
        case modalWindowConstants.CLOSE_MODAL_WINDOW:
            return produce(state, (draft) => {
                draft.isOpen = false;
                draft.fileUrl = null;
            });
        case modalWindowConstants.SET_FILE_MIMETYPE:
            return produce(state, (draft) => {
                draft.fileMimetype = action.payload.fileMimetype;
            });
        case modalWindowConstants.SET_FILE_ID:
            return produce(state, (draft) => {
                draft.fileId = action.payload.fileId;
            });
        case modalWindowConstants.SET_FILE_URL:
            return produce(state, (draft) => {
                draft.fileUrl = action.payload.fileUrl;
            });
        case modalWindowConstants.SET_FILE_BLOB:
            return produce(state, (draft) => {
                draft.fileBlob = action.payload.fileBlob;
            });
        default:
            return state;
    }
}
